module.exports = __webpack_public_path__ + "static/media/coin-and-light.2e58bff6.png";